<div class="flex-col h-100">
    <ui-header-with-breadcrumbs [selectBreadcrumbs]="breadcrumbs"></ui-header-with-breadcrumbs>

    <div class="ui-tab w-100 h-100 flex-col gap-16">


        <div class="flex-row space-between-center">
            <ui-search style="width: 320px"
                       [searchQuery]="search()"
                       (onInput)="search.set($event)"
                       [placeholder]="'COMMON.SEARCH'|translate">
            </ui-search>

            <ui-button type="primary"
                       [text]="'COMMON.CREATE'|translate"
                       (clickAction)="create()">
            </ui-button>
        </div>

        <div class="h-100 min-h-0">
            @if(!selectissLoadingSig()) {
                @if(selectWorkflowsSig()?.length) {
                    <ui-dataset-table [data]="rowsSig()"
                                    [config]="tableConfig()"
                                    (rowAction)="onRowAction($event)">
                    </ui-dataset-table>
                }@else {
                    <ui-no-data [imgSrc]="noResults.imgSrc"
                                [title]="noResults.title|translate">
                    </ui-no-data>
                }
            }@else {
                <ui-preloader [color]="loaderColor.blue"
                            style="padding: 100px 0;">
                </ui-preloader>
            }
        </div>

        <ng-template #toggleCell
                     let-row>
            <ui-toggle (click)="$event.stopPropagation()"
                       [ngModel]="row.enabled !== undefined ? row.enabled : true"
                       (ngModelChange)="changeWorkflowStatus($event, row.graphId)">
            </ui-toggle>
        </ng-template>

        <ng-template #publishedCell
                     let-row>
            <div class="flex-row start-center">
                @if(row.published) {
                    <span class="ui-icon-status-online"></span>
                }@else {
                    <span class="ui-icon-status-offline"></span>
                }
            </div>
        </ng-template>
    </div>
</div>